export default "/shell-logo-white.248229dc68b931000daeb7396ad9d1cf.svg";